import { render, staticRenderFns } from "./Forest1.vue?vue&type=template&id=6335b063&scoped=true"
import script from "./Forest1.vue?vue&type=script&lang=js"
export * from "./Forest1.vue?vue&type=script&lang=js"
import style0 from "./Forest1.vue?vue&type=style&index=0&id=6335b063&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6335b063",
  null
  
)

export default component.exports